import { useQuery, useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";
import { medicationsApi } from "./api";
import { UpsertMedicationRequest } from "./types";

export const useMedications = () =>
  useQuery(queryKeys.medications(), medicationsApi.list);

export const useMedication = (id: number | null) =>
  useQuery(queryKeys.medication(id ?? 0), () => medicationsApi.get(id!), {
    enabled: !!id,
  });

export const useCreateMedication = () => {
  const queryClient = useQueryClient();
  return useMutation((data: UpsertMedicationRequest) => medicationsApi.create(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.medications());
    },
  });
};

export const useUpdateMedication = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, data }: { id: number; data: UpsertMedicationRequest }) =>
      medicationsApi.update(id, data),
    {
      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries(queryKeys.medications());
        queryClient.invalidateQueries(queryKeys.medication(id));
      },
    }
  );
};

export const useDeleteMedication = () => {
  const queryClient = useQueryClient();
  return useMutation((id: number) => medicationsApi.delete(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.medications());
    },
  });
};
